<div class="card main-product-card container-fluid">
  <!-- Header: título y botón Volver -->
  <div class="row justify-content-between align-items-center mb-4">
    <div class="col-auto">
      <h3 class="m-0 font-bold text-muted">Crear Producto</h3>
    </div>
    <div class="col-auto">
      <p-button
        label="Volver"
        icon="pi pi-arrow-left"
        (onClick)="cancel()"
        severity="secondary"
        [rounded]="true"
        size="small"
      />
    </div>
  </div>

  <div class="container-fluid p-0 mt-2">
    <div class="row">
      <!-- Columna izquierda: formulario -->
      <div class="col-lg-8 mb-4">
        <div class="detail-card">
          <div class="detail-card-title">
            <i class="pi pi-shopping-bag"></i> Información Básica
          </div>

          <form [formGroup]="formProduct" class="mt-2">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="pro_name" class="form-label-edit d-block mb-2">Nombre *</label>
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                    <i class="pi pi-tag"></i>
                  </span>
                  <input
                    id="pro_name"
                    type="text"
                    pInputText
                    formControlName="pro_name"
                    placeholder="Nombre del producto"
                    class="largeInput"
                  />
                </div>
                @if (
                  formProduct.controls['pro_name'].hasError('required') &&
                  formProduct.controls['pro_name'].touched
                ) {
                  <span class="text-danger labelError">
                    <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                  </span>
                }
              </div>

              <div class="col-md-6 mb-3">
                <label for="pro_category_id" class="form-label-edit d-block mb-2">Categoría *</label>
                <p-dropdown
                  id="pro_category_id"
                  [options]="ltsCategories"
                  optionLabel="pca_name"
                  optionValue="pca_id"
                  placeholder="Seleccionar categoría"
                  formControlName="pro_category_id"
                  class="largeInput"
                />
                @if (
                  formProduct.controls['pro_category_id'].hasError('required') &&
                  formProduct.controls['pro_category_id'].touched
                ) {
                  <span class="text-danger labelError">
                    <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                  </span>
                }
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="pro_price" class="form-label-edit d-block mb-2">Precio *</label>
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                    <i class="pi pi-dollar"></i>
                  </span>
                  <input
                    id="pro_price"
                    type="text"
                    inputmode="numeric"
                    pInputText
                    appCentsCurrencyInput
                    formControlName="pro_price"
                    placeholder="0,00"
                    class="largeInput"
                  />
                </div>
                @if (
                  formProduct.controls['pro_price'].hasError('required') &&
                  formProduct.controls['pro_price'].touched
                ) {
                  <span class="text-danger labelError">
                    <i class="pi pi-exclamation-triangle mr-1"></i> Campo Requerido
                  </span>
                }
              </div>

              <div class="col-md-6 mb-3">
                <label for="pro_preparation_time_min" class="form-label-edit d-block mb-2">
                  Tiempo Preparación (min)
                </label>
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                    <i class="pi pi-clock"></i>
                  </span>
                  <p-inputNumber
                    id="pro_preparation_time_min"
                    formControlName="pro_preparation_time_min"
                    [min]="0"
                    class="largeInput"
                    styleClass="w-100"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 mb-3">
                <label for="pro_description" class="form-label-edit d-block mb-2">Descripción</label>
                <textarea
                  id="pro_description"
                  pInputTextarea
                  formControlName="pro_description"
                  rows="3"
                  placeholder="Breve descripción del producto..."
                  class="largeInput"
                ></textarea>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <label for="pro_is_featured" class="form-label-edit d-block mb-2">Destacado</label>
                <p-toggleButton
                  id="pro_is_featured"
                  formControlName="pro_is_featured"
                  onLabel="Sí"
                  offLabel="No"
                />
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Columna derecha: guardar e imagen -->
      <div class="col-lg-4 mb-4">
        <div class="detail-card position-sticky" style="top: 2rem; z-index: 20;">
          <div class="detail-card-title">
            <i class="pi pi-save"></i> Guardar Cambios
          </div>
          <p class="text-muted small mb-4">
            Asegúrese de completar todos los campos requeridos (*) antes de guardar la información.
          </p>

          <div class="d-flex flex-column gap-3">
            <p-button
              label="Guardar"
              icon="pi pi-save"
              severity="success"
              [rounded]="true"
              [loading]="loading"
              [disabled]="formProduct.invalid"
              (onClick)="save()"
              styleClass="w-100"
            />
            <p-button
              label="Cancelar"
              icon="pi pi-times"
              severity="secondary"
              [rounded]="true"
              (onClick)="cancel()"
              styleClass="w-100"
            />
          </div>
        </div>

        <div class="detail-card">
          <div class="detail-card-title">
            <i class="pi pi-image"></i> Imagen del Producto
          </div>

          @if (imagePreview) {
            <div class="text-center py-3 border rounded bg-light position-relative">
              <p-image
                [src]="imagePreview"
                alt="Imagen del producto"
                width="160"
                height="160"
                imageClass="rounded border shadow-sm"
                [style]="{ 'object-fit': 'cover' }"
              />
              <div class="mt-3">
                <p-button
                  label="Quitar Imagen"
                  icon="pi pi-trash"
                  severity="danger"
                  [text]="true"
                  size="small"
                  (onClick)="removeImage()"
                />
              </div>
            </div>
          } @else {
            <div class="logo-upload-box text-center p-3">
              <p-fileUpload
                #fileUpload
                mode="basic"
                chooseLabel="Adjuntar Imagen"
                chooseIcon="pi pi-plus"
                [showUploadButton]="false"
                [showCancelButton]="false"
                maxFileSize="7340032"
                (onSelect)="onImageSelect($event.files, fileUpload)"
                accept="image/png,image/jpeg"
                [multiple]="false"
                styleClass="p-button-success p-button-outlined w-100"
              />
              <p class="text-secondary small mt-2 mb-0">PNG o JPG hasta 7MB</p>
            </div>
            <div class="alert alert-info mt-3 py-2 px-3 border-0 rounded-3">
              <i class="pi pi-info-circle me-1 small"></i>
              <span class="small">La imagen es obligatoria para guardar el producto.</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast position="bottom-right" />
